<template>
  <div>
    <the-nav-bar :title="$t('statistics.name')" />
    <div class="body-wrapper">
       <div class="adver-check-wrapper">
         <div class="adver-check-child-wrapper">
          <div class="adver-check-text">{{ $t('statistics.onlyMaker') }}</div>
          <md-switch
            v-model="isAdver"
            @change="adverCheck"
          ></md-switch>
         </div>
       </div>
      <div class="pane">
        <div class="pane-header row-justify-center">
          <span class="pane-header-left">{{ $t('statistics.total') }}</span>
          <span class="pane-header-right num-font">
            {{ userStatistics.total | doFormat(true, ',') }}
            <span class="small">CNY</span>
          </span>
        </div>
        <div class="pane-body">
          <div class="item row-justify-center">
            <span class="item-left">{{ $t('statistics.buyTotal') }}</span>
            <span class="item-right">
              {{ userStatistics.totalBuy | doFormat(true, ',') }}
              <span class="small">CNY</span>
            </span>
          </div>
          <div class="item row-justify-center">
            <span class="item-left">{{ $t('statistics.sellTotal') }}</span>
            <span class="item-right">
              {{ userStatistics.totalSell | doFormat(true, ',') }}
              <span class="small">CNY</span>
            </span>
          </div>
        </div>
      </div>
      <div class="pane filter">
        <div class="pane-header">
          <drop-menu>
            <drop-menu-item
              v-model="type"
              :options="typeList"
              @change="onChange"
            ></drop-menu-item>
            <drop-menu-item
              v-model="cryptoId"
              :options="cryptoList"
              @change="onChange"
            ></drop-menu-item>
            <drop-menu-item
              v-model="legalCurrencyId"
              :options="legalCurrencyList"
              disabled
            ></drop-menu-item>
          </drop-menu>
        </div>
        <div class="pane-body">
          <div class="date row-align-center" @click="goSetTime">
            <span>{{ startTime | formatTime }}</span>
            <span class="division">-</span>
            <span>{{ endTime | formatTime }}</span>
            <span class="icon-dropdown"></span>
          </div>
          <div class="item row-justify-center">
            <span class="item-left">{{ $t('statistics.volume') }}</span>
            <span class="item-right">
              {{ volume | doFormat(true, ',') }} <span class="small">CNY</span>
            </span>
          </div>
          <div class="item row-justify-center">
            <span class="item-left">{{ $t('statistics.price') }}</span>
            <span class="item-right">
              {{ averagePrice | doFormat(true, ',') }}
              <span class="small">CNY</span>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TheNavBar from '@/components/the-nav-bar';
import dropMenu from '@/components/drop-menu.vue';
import dropMenuItem from '@/components/drop-menu-item.vue';
import { mapState } from 'vuex';
import { getStatistics } from '@/api/user';
import moment from 'moment';
import { Toast } from 'mand-mobile';
import { formatValueByGapStep } from 'mand-mobile/components/_util/formate-value';
import {Switch} from 'mand-mobile';
// import noSci from '@/utils/no-sci';
export default {
  components: { 
    TheNavBar, 
    dropMenu, 
    dropMenuItem, 
    [Switch.name]: Switch,
  },
  data() {
    return {
      type: 'sell',
      cryptoId: 'null',
      legalCurrencyId: '',
      startTime: '',
      endTime: '',
      volume: '0',
      averagePrice: '0',
      isAdver: false,
    };
  },
  filters: {
    formatTime(unix, template = 'YYYY/MM/DD') {
      return moment(+unix).format(template);
    },
    doFormat(value, hasSeparator, separator) {
      if (!hasSeparator) {
        return value;
      }

      value = '' + value;

      const numberParts = value.split('.');
      let integerValue = numberParts[0];
      const decimalValue = numberParts[1] || '';

      let sign = '';
      if (integerValue.startsWith('-')) {
        integerValue = integerValue.substring(1);
        sign = '-';
      }

      const formateValue = formatValueByGapStep(
        3,
        integerValue,
        separator,
        'right',
        0,
        1,
      );
      return decimalValue
        ? `${sign}${formateValue.value}.${decimalValue}`
        : `${sign}${formateValue.value}`;
    },
  },
  computed: {
    ...mapState({
      settings: state => state.settings,
      userInfo: state => state.userInfo,
      userStatistics: state => state.userStatistics,
    }),
    cryptoList() {
      return [
        {
          value: 'null',
          label: this.$t('exchange.noLimit'),
        },
      ].concat(
        this.settings.cryptoList
          .map(item => {
            return {
              value: item.id,
              label: item.symbol,
            };
          })
          .filter(item => this.userStatistics.assetIds.includes(item.value)),
      );
    },
    legalCurrencyList() {
      return this.settings.legalCurrencyList.map(item => {
        return {
          value: item.id,
          label: item.unit,
        };
      });
    },
    typeList() {
      return [
        {
          value: 'buy',
          label: this.$t('statistics.buy'),
        },
        {
          value: 'sell',
          label: this.$t('statistics.sell'),
        },
      ];
    },
  },
  mounted() {
    const orderStatisticTime = window.localStorage.getItem(
      'orderStatisticTime',
    );
    if (orderStatisticTime) {
      [this.startTime, this.endTime] = orderStatisticTime.split('_');
      window.localStorage.removeItem('orderStatisticTime');
    } else {
      const now = moment().endOf('day');
      this.endTime = +now;
      this.startTime = +now.subtract(6, 'day').startOf('day');
    }
    let p = Promise.resolve();
    if (!this.settings.isSettingsLoaded) {
      p = this.$store.dispatch('updateSettings');
    }
    p.then(() => {
      this.legalCurrencyId = this.userInfo.defaultLegalCurrencyId;
      this.isAdver = this.userInfo.hasCertified;
      return this.loadDataIsAdver();
    })
      .then(() => {
        return this.loadData();
      })
      .catch(err => {
        Toast.failed(err.message);
      });
  },
  methods: {
    loadData() {
      return getStatistics(
        this.type,
        this.cryptoId === 'null' ? '' : this.cryptoId,
        this.legalCurrencyId,
        Math.floor(this.startTime / 1000),
        Math.floor(this.endTime / 1000),
        this.isAdver,
      ).then(({ data: d }) => {
        this.volume = d.turnover || 0;
        this.averagePrice = d.avg_price || 0;
      });
    },
    loadDataIsAdver() {
      return getStatistics(  
        null,
        null,
        null,
        null,
        null,
        this.isAdver,
      ).then(data => {
        const d = data.data;
        this.$store.commit('setUserStatistic', {
          total: d.total || 0,
          totalBuy: d.totalBuy || 0,
          totalSell: d.totalSell || 0,
          assetIds: Array.isArray(d.assetIds) ? d.assetIds : [],
        });
      });
    },
    onChange() {
      Toast.loading(this.$t('common.loading'));
      this.loadData()
        .then(() => {
          Toast.hide();
        })
        .catch(err => {
          Toast.failed(err.message);
        });
    },
    goSetTime() {
      window.localStorage.setItem(
        'orderStatisticTime',
        `${this.startTime}_${this.endTime}`,
      );
      this.$router.push({
        path: '/mine/statistics/setTime',
      });
    },
    adverCheck() {
      let q = Promise.resolve();
      q.then(() => {
        this.legalCurrencyId = this.userInfo.defaultLegalCurrencyId;
        return this.loadDataIsAdver();
      }).then(() => {
        this.onChange();
      })
        .catch(err => {
          Toast.failed(err.message);
        });
    },
  },
};
</script>

<style lang="stylus" scoped>
.main-view {
  background: #F8FBFC;
}

.body-wrapper {
  padding-bottom: 80vw;
  background: #F8FBFC;
}

.adver-check-wrapper
  text-align: right;
  width:100%;
  .adver-check-child-wrapper 
     display: inline-flex;
     align-items:center;
     padding: 3vw 4.8vw 0 4.8vw;
     .adver-check-text 
        padding-right: 3vw;
        color: #84969c;
  
.pane {
  margin: 4.8vw;
  border: 0.27vw solid #eaf1f3;
  border-radius: 2.67vw;
  line-height: 5.33vw;
  background: #fff;

  .pane-header {
    padding: 6.67vw 4.8vw;
    border-bottom: 0.27vw solid #eaf1f3;

    .pane-header-left {
      font-size: 3.2vw;
    }

    .pane-header-right {
      font-size: 4.27vw;
      font-weight: 600;

      .small {
        font-size: 2.67vw;
        font-weight: normal;
      }
    }
  }

  .pane-body {
    padding: 4.8vw;
    font-size: 3.2vw;
    color: #84969C;

    .small {
      font-size: 2.67vw;
    }
  }
}

.filter {
  overflow: hidden;

  .pane-header {
    padding: 0;
  }

  & >>> {
    .drop-menu-item {
      width: auto;
      left: 4.8vw;
      right: 4.8vw;
    }

    .md-popup-mask {
      display: none;
    }

    .popup-body {
      border: 0.27vw solid #eaf1f3;
      border-top: none;
    }

    .scroller {
      height: 80vw;
    }

    .cell-item {
      font-size: 3.2vw;
    }
  }
}

.date {
  color: color-primary;

  .division {
    margin: 0 1.07vw;
  }

  .icon-dropdown {
    margin-left: 1.07vw;
    width: 0;
    height: 0;
    border: 1.07vw solid transparent;
    border-top-color: currentColor;
    border-bottom: none;
    transform: rotateZ(0deg);
    transition: transform 0.2s linear;
  }
}
</style>
